import React from 'react';
import ActiveCall from '../components/ActiveCall';
import CallList from '../components/CallList';
import Dialler from '../components/Dialler';
import { useSelector } from 'react-redux';
import styles from '../styles/centerColumn.scss';
const CenterColumn = () => {
    const hasActiveCall = useSelector((state) => !!state.calls.find((c) => c.active || (c.ringing && c.direction === 'IN')));
    const callCount = useSelector((state) => state.calls.length);
    const ongoingCalls = callCount > 0;
    let callListResponsiveClass = '';
    callListResponsiveClass = ongoingCalls
        ? styles.call_list_container_peek
        : styles.call_list_container_hidden;
    const callListClass = `
    ${styles.call_list_container}
    ${callListResponsiveClass}
  `;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.dialler_container }, hasActiveCall ? React.createElement(ActiveCall, null) : React.createElement(Dialler, null)),
        React.createElement("div", { className: callListClass },
            React.createElement(CallList, null))));
};
export default CenterColumn;
